export default "__VITE_PUBLIC_ASSET__2bd209eb__"